import { foundationSegmentedItemStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
import { ColorHEX } from '../_common/colors.hex';
export const zeroSegmentedItemStyles = (context, definition) => css `
  ${foundationSegmentedItemStyles(context, definition)}
  :host {
    color: var(--neutral-stroke-rest);
    font-size: var(--type-ramp-minus-1-font-size);
  }

  :host([aria-checked='true']) {
    color: ${ColorHEX.white};
  }
`;
